// src/pages/race/index.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { motion } from "framer-motion";
import sanawarImg from "../../img/Parallax/form-bg.jpg";
import chambaImg from "../../img/Parallax/chamba-bg.jpg";
import sanawarLogo from "../../img/Parallax/sanawar-logo.png";
import chambaLogo from "../../img/Parallax/chamba-logo.png";

export default function RacePage() {
  const navigate = useNavigate();

  const races = [
    {
      title: "Tour de Sanawar 2025",
      date: "Registration Closed",
      description:
        "Experience the ultimate cycling challenge through the hills of Sanawar. A race that blends endurance, speed, and scenic beauty.",
      icon: sanawarLogo,
      image: sanawarImg,
      route: "/race/tds-2025",
    },
    {
      title: "MTB Chamba 2026",
      date: "March 21-22, 2026",
      description:
        "Take on the rugged terrains of Chamba. The MTB race is for the bold, the skilled, and the adventurous riders.",
      icon: chambaLogo,
      image: chambaImg,
      route: "/race/chamba",
    },
  ];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "radial-gradient(circle at 20% 20%, #0a192f, #020617)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 5,
        flexWrap: "wrap",
        padding: 6,
      }}
    >
      {races.map((race, index) => (
        <motion.div
          key={race.title}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.98 }}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.2, duration: 0.6 }}
          style={{ borderRadius: "20px", cursor: "pointer" }}
          onClick={() => navigate(race.route)}
        >
          <Card
            sx={{
              width: 380,
              height: 450,
              borderRadius: "20px",
              overflow: "hidden",
              position: "relative",
              boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
              background: "rgba(255, 255, 255, 0.05)",
              backdropFilter: "blur(8px)",
              border: "1px solid rgba(255,255,255,0.1)",
              transition: "all 0.4s ease",
              "&:hover": {
                borderColor: "rgba(0, 255, 255, 0.4)",
                boxShadow: "0 0 25px rgba(0,255,255,0.3)",
              },
            }}
          >
            {/* Image Section */}
            <Box
              sx={{
                height: "60%",
                backgroundImage: `url(${race.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Gradient Overlay */}
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0.2))",
                  zIndex: 1,
                }}
              />

              {/* Race Icon */}
              <Box
                sx={{
                  position: "absolute",
                  top: "10px",
                  left: "20px",
                  zIndex: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "70px",
                  height: "70px",
                }}
              >
                <img
                  src={race.icon}
                  alt="race-icon"
                  className="w-18 h-18 object-contain"
                  style={{ filter: "drop-shadow(0 0 4px rgba(0,0,0,0.6))" }}
                />
              </Box>

              {/* 🗓️ Date Badge */}
              <Box
                sx={{
                  position: "absolute",
                  top: "15px",
                  right: "20px",
                  zIndex: 3,
                  background:
                    "linear-gradient(90deg, #06b6d4, #3b82f6, #7c3aed)",
                  color: "#fff",
                  px: 2,
                  py: 0.5,
                  borderRadius: "20px",
                  fontSize: "13px",
                  fontWeight: 600,
                  letterSpacing: "0.4px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.25)",
                  textTransform: "uppercase",
                }}
              >
                {race.date}
              </Box>
            </Box>

            {/* Text Section */}
            <CardContent
              sx={{
                color: "#fff",
                p: 3,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: 0.6,
                  mb: 1,
                  color: "#00e6ff",
                }}
              >
                {race.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "rgba(255,255,255,0.8)",
                  fontSize: 15,
                  lineHeight: 1.7,
                }}
              >
                {race.description}
              </Typography>
            </CardContent>
          </Card>
        </motion.div>
      ))}
    </Box>
  );
}
